import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
  Input,
} from "@altimateai/lego";
import { Stack } from "@altimateai/lego";
import { Control } from "react-hook-form";
import { SnowflakeFormValues } from "../SnowflakeConnection";

interface WarehouseFormFieldProps {
  control: Control<SnowflakeFormValues>;
}

export const WarehouseFormField = ({ control }: WarehouseFormFieldProps) => {
  return (
    <FormField
      control={control}
      name="warehouse"
      render={({ field }) => (
        <FormItem>
          <FormLabel>
            <Stack justify="between" align="center">
              Warehouse
              <span className="al-text-blue-500 al-text-xs">
                (XS Size Warehouse Recommended)
              </span>
            </Stack>
          </FormLabel>
          <FormControl>
            <Input {...field} placeholder="ALTIMATE_WH" className="al-mt-1" />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
